import { Dispatch } from "redux";
import { setErrorMessage } from "../../Redux/Slices/alert.slice";
import { setFocusTo } from "../../Redux/Slices/focusOnValidation.slice";
import { validateForm } from "../formValidation.helper";

export const verifyParentsRegistrationFields = ({
  fieldsToVerify,
  dispatch,
  skipPasswordValidation = false,
}: {
  fieldsToVerify: {
    firstName: string;
    lastName: string;
    gender: string;
    email: string;
    password?: string;
    confirmPassword?: string;
    mobile: string;
    parentalRelationship: string;
    address: string;
  };
  dispatch: Dispatch;
  skipPasswordValidation?: boolean;
}): boolean => {
  const {
    firstName,
    lastName,
    gender,
    email,
    password,
    confirmPassword,
    mobile,
    parentalRelationship,
    address,
  } = fieldsToVerify;

  const parentValidationFields = [
    {
      data: firstName,
      errorMessage: "First name of parents is required.",
      focusTo: "register-parents-firstname",
    },

    {
      data: lastName,
      errorMessage: "Last name of parents is required.",
      focusTo: "register-parents-lastname",
    },
    {
      data: mobile,
      errorMessage: "Mobile number is required.",
      focusTo: "register-parents-mobile",
    },
    {
      data: address,
      errorMessage: "Address is required.",
      focusTo: "register-parents-address",
    },

    {
      data: gender,
      errorMessage: "Gander is required.",
      focusTo: "register-parents-gender",
    },
    {
      data: email,
      errorMessage: "Email is required.",
      focusTo: "register-parents-email",
    },
    {
      data: parentalRelationship,
      errorMessage: "parentalRelationship is required.",
      focusTo: "register-parents-parental-relationship",
    },
  ];

  if (!skipPasswordValidation) {
    parentValidationFields.push(
      ...[
        {
          data: password || "",
          errorMessage: "Password is required",
          focusTo: "register-parents-password",
        },
        {
          data: confirmPassword || "",
          errorMessage: "Please confirm your password",
          focusTo: "register-parents-confirm-password",
        },
      ]
    );
  }

  let isValid = false;

  isValid = validateForm({ validate: parentValidationFields, dispatch });

  if (!skipPasswordValidation && password !== confirmPassword) {
    dispatch(
      setErrorMessage("The password and confirm password fields do not match")
    );
    dispatch(setFocusTo("register-parents-confirm-password"));
    isValid = false;
  }

  return isValid;
};
